import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import theme from "./Theme"
import { ThemeUIProvider } from "theme-ui"
import { Provider } from "react-redux"
import { store } from "./store"
import "./i18n"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
 <React.StrictMode>
  <ThemeUIProvider theme={theme}>
   <Provider store={store}>
    <App />
   </Provider>
  </ThemeUIProvider>
 </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
